(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5304],{

/***/ 15304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Header_Header; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_babel-plugin-macros@3.1.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.101.6/node_modules/next/image.js
var next_image = __webpack_require__(26538);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_babel-plugin-macros@3.1.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.101.6/node_modules/next/link.js
var next_link = __webpack_require__(87597);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.3.1_babel-plugin-macros@3.1.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.101.6/node_modules/next/router.js
var next_router = __webpack_require__(96376);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-loading-skeleton@3.5.0_react@18.2.0/node_modules/react-loading-skeleton/dist/index.js
var dist = __webpack_require__(31922);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-loading-skeleton@3.5.0_react@18.2.0/node_modules/react-loading-skeleton/dist/skeleton.css
var skeleton = __webpack_require__(97508);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-redux@9.3.0_@types+react@18.0.21_react@18.2.0_redux@5.0.1/node_modules/react-redux/dist/react-redux.mjs
var react_redux = __webpack_require__(71901);
// EXTERNAL MODULE: ./node_modules/.pnpm/axios@1.18.1_debug@4.4.3_supports-color@7.2.0__supports-color@7.2.0/node_modules/axios/lib/axios.js + 50 modules
var axios = __webpack_require__(81944);
// EXTERNAL MODULE: ./utils/setAuth.js
var setAuth = __webpack_require__(86737);
// EXTERNAL MODULE: ./store/user/userActionTypes.ts
var userActionTypes = __webpack_require__(34216);
// EXTERNAL MODULE: ./store/user/reducer.ts
var reducer = __webpack_require__(54970);
// EXTERNAL MODULE: ./components/Header/profileview.module.scss
var profileview_module = __webpack_require__(21416);
var profileview_module_default = /*#__PURE__*/__webpack_require__.n(profileview_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/@react-oauth+google@0.12.2_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/@react-oauth/google/dist/index.esm.js
var index_esm = __webpack_require__(77086);
// EXTERNAL MODULE: ./utils/authCookie.ts
var authCookie = __webpack_require__(16786);
// EXTERNAL MODULE: ./components/Typography/index.ts + 1 modules
var Typography = __webpack_require__(39181);
;// CONCATENATED MODULE: ./components/Header/ProfileView.tsx










var ProfileView = function(param) {
    var setShowAccount = param.setShowAccount, setIsMobileShow = param.setIsMobileShow;
    var ref;
    var ref1 = (0,react.useState)(true), show = ref1[0], setShow = ref1[1];
    var router = (0,next_router.useRouter)();
    var menuRef = (0,react.useRef)(null);
    var ref2 = (0,reducer/* useUserMaster */.T)(), masterUser = ref2.masterUser, busy = ref2.busy;
    (0,react.useEffect)(function() {
        var handler = function(e) {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setShowAccount(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return function() {
            document.removeEventListener("mousedown", handler);
        };
    }, [
        setShowAccount
    ]);
    var handleClosePopup = function() {
        setShow(false);
        setShowAccount(false);
        setIsMobileShow(false);
    };
    var handleLogout = function() {
        localStorage.clear();
        sessionStorage.clear();
        (0,authCookie/* clearIsLoggedInCookie */.i)();
        (0,index_esm/* googleLogout */.Kz)();
        router.push("/");
        window.location.reload();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: show && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (profileview_module_default()).profileDropdown,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (profileview_module_default()).profileContainer,
                ref: menuRef,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (profileview_module_default()).profileMenu,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (profileview_module_default()).mainResponsivePopup,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (profileview_module_default()).toplogin,
                                    children: masterUser.email ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (profileview_module_default()).avatarIcon,
                                        style: {
                                            border: "none",
                                            cursor: "auto"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: ((ref = masterUser.profileImage) === null || ref === void 0 ? void 0 : ref.url) || "/avatar.svg",
                                            loading: "lazy",
                                            alt: "Avatar"
                                        })
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SkeletonTheme */.y, {
                                        baseColor: "#202020",
                                        highlightColor: "#444",
                                        borderRadius: 50,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                            width: 40,
                                            height: 40
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (profileview_module_default()).topUserEmail,
                                    children: masterUser.email ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (profileview_module_default()).topUserEmailDiv,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.ZP, {
                                                variant: "text-sm",
                                                color: "grayDark-50",
                                                children: "".concat(masterUser.firstName || "-", " ").concat(masterUser.lastName || "")
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.ZP, {
                                                variant: "text-sm",
                                                color: "grayDark-400",
                                                children: masterUser.email
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (profileview_module_default()).topUserEmailDiv,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SkeletonTheme */.y, {
                                                baseColor: "#202020",
                                                highlightColor: "#444",
                                                borderRadius: 50,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                    width: 100,
                                                    height: 20
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SkeletonTheme */.y, {
                                                baseColor: "#202020",
                                                highlightColor: "#444",
                                                borderRadius: 50,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                    width: 150,
                                                    height: 20
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (profileview_module_default()).divider
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/members-area?tab=myaccount",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: (profileview_module_default()).menuItem,
                                onClick: handleClosePopup,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (profileview_module_default()).menuIcon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/user.svg",
                                            alt: "User"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.ZP, {
                                        variant: "text-sm",
                                        color: "primary",
                                        weight: "normal",
                                        className: (profileview_module_default()).menuText,
                                        children: "My Account"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/members-area?tab=myorders",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: (profileview_module_default()).menuItem,
                                onClick: handleClosePopup,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (profileview_module_default()).menuIcon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/order.svg",
                                            alt: "Orders"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.ZP, {
                                        variant: "text-sm",
                                        color: "primary",
                                        weight: "normal",
                                        className: (profileview_module_default()).menuText,
                                        children: "My Orders"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/members-area?tab=mysubscriptions",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: (profileview_module_default()).menuItem,
                                onClick: handleClosePopup,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (profileview_module_default()).menuIcon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 16 16",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M1.33333 5.33333C1.33333 4.59695 1.93029 4 2.66667 4H13.3333C14.0697 4 14.6667 4.59695 14.6667 5.33333V12C14.6667 12.7364 14.0697 13.3333 13.3333 13.3333H2.66667C1.93029 13.3333 1.33333 12.7364 1.33333 12V5.33333Z",
                                                    stroke: "#61656C",
                                                    strokeWidth: "1.5",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M1.33333 6.66667H14.6667",
                                                    stroke: "#61656C",
                                                    strokeWidth: "1.5",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M4 9.33333H5.33333M7.33333 9.33333H10.6667",
                                                    stroke: "#61656C",
                                                    strokeWidth: "1.5",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                    d: "M12 2.66667V4",
                                                    stroke: "#61656C",
                                                    strokeWidth: "1.5",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.ZP, {
                                        variant: "text-sm",
                                        color: "primary",
                                        weight: "normal",
                                        className: (profileview_module_default()).menuText,
                                        children: "My Subscriptions"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/downloads",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: (profileview_module_default()).menuItem,
                                onClick: handleClosePopup,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (profileview_module_default()).menuIcon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/download-cloud.svg",
                                            alt: "Downloads"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.ZP, {
                                        variant: "text-sm",
                                        color: "primary",
                                        weight: "normal",
                                        className: (profileview_module_default()).menuText,
                                        children: "Downloads"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "/members-area?tab=myaddresses",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                className: (profileview_module_default()).menuItem,
                                onClick: handleClosePopup,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (profileview_module_default()).menuIcon,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/address.svg",
                                            alt: "Addresses"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.ZP, {
                                        variant: "text-sm",
                                        color: "primary",
                                        weight: "normal",
                                        className: (profileview_module_default()).menuText,
                                        children: "My Addresses"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (profileview_module_default()).divider
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (profileview_module_default()).menuItem,
                            onClick: handleLogout,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (profileview_module_default()).menuIcon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/logout.svg",
                                        alt: "Logout"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.ZP, {
                                    variant: "text-sm",
                                    color: "primary",
                                    weight: "normal",
                                    className: (profileview_module_default()).menuText,
                                    children: "Log out"
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var Header_ProfileView = (ProfileView);

// EXTERNAL MODULE: ./components/Header/header.module.scss
var header_module = __webpack_require__(47462);
var header_module_default = /*#__PURE__*/__webpack_require__.n(header_module);
// EXTERNAL MODULE: ./components/Button/index.ts + 1 modules
var Button = __webpack_require__(32033);
// EXTERNAL MODULE: ./node_modules/.pnpm/@tanstack+react-query@4.44.0_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 8 modules
var useQuery = __webpack_require__(86607);
;// CONCATENATED MODULE: ./components/Header/Header.tsx



















var Header = function() {
    var ref, ref1;
    var dispatch = (0,react_redux/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var pathname = router.pathname, query = router.query;
    var navRef = (0,react.useRef)(null);
    var ref2 = (0,reducer/* useUserMaster */.T)(), masterUser = ref2.masterUser, busy = ref2.busy;
    // State management
    var ref3 = (0,react.useState)(false), showAccount = ref3[0], setShowAccount = ref3[1];
    var ref4 = (0,react.useState)(true), showLinkLast = ref4[0], setShowLinkLast = ref4[1];
    var ref5 = (0,react.useState)(false), isMobileShow = ref5[0], setIsMobileShow = ref5[1];
    var ref6 = (0,react.useState)(false), showChat = ref6[0], setShowChat = ref6[1];
    var ref7 = (0,react.useState)(null), authToken = ref7[0], setAuthToken = ref7[1];
    var hamBurgerMenu = function() {
        setIsMobileShow(!isMobileShow);
    };
    var handleLogin = function() {
        router.push("/login");
        setIsMobileShow(false);
    };
    var handleLogout = function() {
        localStorage.clear();
        sessionStorage.clear();
        (0,authCookie/* clearIsLoggedInCookie */.i)();
        (0,index_esm/* googleLogout */.Kz)();
        router.push("/");
        window.location.reload();
    };
    // Effects
    (0,react.useEffect)(function() {
        if (true) {
            var item = localStorage.getItem("auth-token");
            if (item) {
                (0,setAuth/* default */.Z)(item);
                setShowLinkLast(false);
                setAuthToken(item);
                dispatch({
                    type: userActionTypes/* REQUEST_MASTER_USER */.Gn
                });
            }
        }
    }, [
        dispatch
    ]);
    (0,react.useEffect)(function() {
        var handler = function(e) {
            if (navRef.current && !navRef.current.contains(e.target)) {
                setIsMobileShow(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return function() {
            return document.removeEventListener("mousedown", handler);
        };
    }, []);
    // Cached so navigating between pages doesn't re-hit /user every time —
    // only the visibility check (based on pathname) needs to re-run.
    var ref8 = (0,useQuery/* useQuery */.a)([
        "header-user-check",
        authToken
    ], function() {
        return axios/* default.get */.Z.get("".concat("https://api.vxfx.io", "/user"), {
            headers: {
                Authorization: "".concat(authToken)
            }
        }).then(function(response) {
            return response.data;
        });
    }, {
        enabled: Boolean(authToken),
        staleTime: 30000
    }), headerUserData = ref8.data, headerUserFetchFailed = ref8.isError;
    (0,react.useEffect)(function() {
        if (!authToken) return;
        if (headerUserFetchFailed) {
            setShowChat(false);
            return;
        }
        if (headerUserData) {
            var userData = headerUserData.data;
            setShowChat(userData && router.pathname !== "/supportchat");
            dispatch({
                type: userActionTypes/* REQUEST_MASTER_USER */.Gn
            });
        }
    }, [
        authToken,
        headerUserData,
        headerUserFetchFailed,
        router.pathname,
        dispatch
    ]);
    var isSupportChat = router.pathname === "/supportchat";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                className: "".concat((header_module_default()).headerMainDiv, "   ").concat(isSupportChat ? (header_module_default()).headerChat : ""),
                role: "banner",
                "aria-label": "Main navigation",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (header_module_default()).headerPopupContainer,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (header_module_default()).headerSubDiv,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                                className: (header_module_default()).nav,
                                role: "navigation",
                                "aria-label": "Main navigation",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (header_module_default()).options,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/",
                                                "aria-label": "VxFX Home",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: (header_module_default()).logo,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: "/vxfx-app-name-book.svg",
                                                        alt: "VxFX Logo",
                                                        width: 119,
                                                        height: 44,
                                                        priority: true
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (header_module_default()).links,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (header_module_default()).linkItem,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                                    variant: "text-md",
                                                                    as: "p",
                                                                    color: "primary",
                                                                    weight: "normal",
                                                                    className: pathname === "/" ? (header_module_default()).linkStyle : "",
                                                                    children: "Home"
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (header_module_default()).linkItem,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/video-plugin-framework/vxfx",
                                                            prefetch: false,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                                    variant: "text-md",
                                                                    as: "p",
                                                                    color: "primary",
                                                                    weight: "normal",
                                                                    className: pathname.includes("/video-plugin-framework/") ? (header_module_default()).linkStyle : "",
                                                                    children: "Product"
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (header_module_default()).linkItem,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/about-us",
                                                            prefetch: false,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                                    variant: "text-md",
                                                                    as: "p",
                                                                    color: "primary",
                                                                    weight: "normal",
                                                                    className: pathname === "/about-us" ? (header_module_default()).linkStyle : "",
                                                                    children: "About Us"
                                                                })
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (header_module_default()).linkItem,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/contact-us",
                                                            prefetch: false,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                                    variant: "text-md",
                                                                    color: "primary",
                                                                    weight: "normal",
                                                                    className: pathname === "/contact-us" ? (header_module_default()).linkStyle : "",
                                                                    children: "Contact Us"
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    showLinkLast && !masterUser.firstName ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                        variant: "primary",
                                        size: "md",
                                        label: "Log In",
                                        onClick: handleLogin
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (header_module_default()).mainsigninButtonDiv,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (header_module_default()).subsigninButtonDiv,
                                            children: [
                                                masterUser.email ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (header_module_default()).avatarIcon,
                                                    onClick: function() {
                                                        setShowAccount(!showAccount);
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: ((ref = masterUser.profileImage) === null || ref === void 0 ? void 0 : ref.url) || "/avatar.svg",
                                                        loading: "lazy",
                                                        alt: "Avatar"
                                                    })
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SkeletonTheme */.y, {
                                                    baseColor: "#202020",
                                                    highlightColor: "#444",
                                                    borderRadius: 50,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                        width: 40,
                                                        height: 40
                                                    })
                                                }),
                                                showAccount && /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_ProfileView, {
                                                    setIsMobileShow: setIsMobileShow,
                                                    setShowAccount: setShowAccount
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                                className: (header_module_default()).mobilenav,
                                ref: navRef,
                                role: "navigation",
                                "aria-label": "Mobile navigation",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/",
                                        "aria-label": "Epen Home",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: (header_module_default()).logo,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: "/vxfx-app-name-book.svg",
                                                alt: "VxFX Logo",
                                                width: 119,
                                                height: 44,
                                                priority: true
                                            })
                                        })
                                    }),
                                    isMobileShow && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (header_module_default()).signinResponsiveDiv,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (header_module_default()).sidebar,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: (header_module_default()).menuItem,
                                                        onClick: function() {
                                                            setIsMobileShow(false);
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                            variant: "text-md",
                                                            color: "primary",
                                                            weight: "medium",
                                                            className: pathname === "/" ? (header_module_default()).linkStyle : "",
                                                            children: "Home"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/video-plugin-framework/vxfx",
                                                    prefetch: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: (header_module_default()).menuItem,
                                                        onClick: function() {
                                                            setIsMobileShow(false);
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                            variant: "text-md",
                                                            color: "primary",
                                                            weight: "medium",
                                                            className: pathname.includes("/video-plugin-framework/") ? (header_module_default()).linkStyle : "",
                                                            children: "Product"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/about-us",
                                                    prefetch: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: (header_module_default()).menuItem,
                                                        onClick: function() {
                                                            setIsMobileShow(false);
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                            variant: "text-md",
                                                            color: "primary",
                                                            weight: "medium",
                                                            className: pathname === "/about-us" ? (header_module_default()).linkStyle : "",
                                                            children: "About Us"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/contact-us",
                                                    prefetch: false,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        className: (header_module_default()).menuItem,
                                                        onClick: function() {
                                                            setIsMobileShow(false);
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                            variant: "text-md",
                                                            color: "primary",
                                                            weight: "medium",
                                                            className: pathname === "/contact-us" ? (header_module_default()).linkStyle : "",
                                                            children: "Contact Us"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (header_module_default()).divider
                                                }),
                                                showLinkLast && !masterUser.firstName ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                    variant: "primary",
                                                    size: "md",
                                                    label: "Log In",
                                                    fullWidth: true,
                                                    onClick: handleLogin
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/members-area?tab=myaccount",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                className: (header_module_default()).menuItem,
                                                                onClick: function() {
                                                                    setIsMobileShow(false);
                                                                },
                                                                style: {
                                                                    flexDirection: "row",
                                                                    gap: "12px",
                                                                    alignItems: "center"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (header_module_default()).menuIcon,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            src: "/user.svg",
                                                                            alt: "User",
                                                                            width: 16,
                                                                            height: 16
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                                        variant: "text-md",
                                                                        color: "primary",
                                                                        weight: "medium",
                                                                        className: pathname === "/members-area?tab=myaccount" ? (header_module_default()).linkStyle : "",
                                                                        children: "My Account"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/members-area?tab=myorders",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                className: (header_module_default()).menuItem,
                                                                onClick: function() {
                                                                    setIsMobileShow(false);
                                                                },
                                                                style: {
                                                                    flexDirection: "row",
                                                                    gap: "12px",
                                                                    alignItems: "center"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (header_module_default()).menuIcon,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            src: "/order.svg",
                                                                            alt: "Orders",
                                                                            width: 16,
                                                                            height: 16
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                                        variant: "text-md",
                                                                        color: "primary",
                                                                        weight: "medium",
                                                                        className: pathname === "/members-area?tab=myorders" ? (header_module_default()).linkStyle : "",
                                                                        children: "My Orders"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/members-area?tab=mysubscriptions",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                className: (header_module_default()).menuItem,
                                                                onClick: function() {
                                                                    setIsMobileShow(false);
                                                                },
                                                                style: {
                                                                    flexDirection: "row",
                                                                    gap: "12px",
                                                                    alignItems: "center"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (header_module_default()).menuIcon,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
                                                                            width: "16",
                                                                            height: "16",
                                                                            viewBox: "0 0 16 16",
                                                                            fill: "none",
                                                                            xmlns: "http://www.w3.org/2000/svg",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                                    d: "M1.33333 5.33333C1.33333 4.59695 1.93029 4 2.66667 4H13.3333C14.0697 4 14.6667 4.59695 14.6667 5.33333V12C14.6667 12.7364 14.0697 13.3333 13.3333 13.3333H2.66667C1.93029 13.3333 1.33333 12.7364 1.33333 12V5.33333Z",
                                                                                    stroke: "#61656C",
                                                                                    strokeWidth: "1.5",
                                                                                    strokeLinecap: "round",
                                                                                    strokeLinejoin: "round"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                                    d: "M1.33333 6.66667H14.6667",
                                                                                    stroke: "#61656C",
                                                                                    strokeWidth: "1.5",
                                                                                    strokeLinecap: "round",
                                                                                    strokeLinejoin: "round"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                                    d: "M4 9.33333H5.33333M7.33333 9.33333H10.6667",
                                                                                    stroke: "#61656C",
                                                                                    strokeWidth: "1.5",
                                                                                    strokeLinecap: "round",
                                                                                    strokeLinejoin: "round"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                                                    d: "M12 2.66667V4",
                                                                                    stroke: "#61656C",
                                                                                    strokeWidth: "1.5",
                                                                                    strokeLinecap: "round",
                                                                                    strokeLinejoin: "round"
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                                        variant: "text-md",
                                                                        color: "primary",
                                                                        weight: "medium",
                                                                        className: pathname === "/members-area?tab=mysubscriptions" ? (header_module_default()).linkStyle : "",
                                                                        children: "My Subscriptions"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/downloads",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                className: (header_module_default()).menuItem,
                                                                onClick: function() {
                                                                    setIsMobileShow(false);
                                                                },
                                                                style: {
                                                                    flexDirection: "row",
                                                                    gap: "12px",
                                                                    alignItems: "center"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (header_module_default()).menuIcon,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            src: "/download-cloud.svg",
                                                                            alt: "Downloads",
                                                                            width: 16,
                                                                            height: 16
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                                        variant: "text-md",
                                                                        color: "primary",
                                                                        weight: "medium",
                                                                        className: pathname === "/downloads" ? (header_module_default()).linkStyle : "",
                                                                        children: "Downloads"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: "/members-area?tab=myaddresses",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                className: (header_module_default()).menuItem,
                                                                onClick: function() {
                                                                    setIsMobileShow(false);
                                                                },
                                                                style: {
                                                                    flexDirection: "row",
                                                                    gap: "12px",
                                                                    alignItems: "center",
                                                                    marginBottom: "12px"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (header_module_default()).menuIcon,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            src: "/address.svg",
                                                                            alt: "Addresses",
                                                                            width: 16,
                                                                            height: 16
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                                        variant: "text-md",
                                                                        color: "primary",
                                                                        weight: "medium",
                                                                        className: pathname === "/members-area?tab=myaddresses" ? (header_module_default()).linkStyle : "",
                                                                        children: "My Addresses"
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: (header_module_default()).mainResponsivePopup,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (header_module_default()).toplogin,
                                                                    children: masterUser.email ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                        className: (header_module_default()).avatarIcon,
                                                                        style: {
                                                                            border: "none",
                                                                            cursor: "auto"
                                                                        },
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                            src: ((ref1 = masterUser.profileImage) === null || ref1 === void 0 ? void 0 : ref1.url) || "/avatar.svg",
                                                                            loading: "lazy",
                                                                            alt: "Avatar"
                                                                        })
                                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SkeletonTheme */.y, {
                                                                        baseColor: "#202020",
                                                                        highlightColor: "#444",
                                                                        borderRadius: 50,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                                            width: 40,
                                                                            height: 40
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (header_module_default()).topUserEmail,
                                                                    children: [
                                                                        masterUser.email ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (header_module_default()).topUserEmailDiv,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                                                    variant: "text-sm",
                                                                                    color: "grayDark-50",
                                                                                    children: "".concat(masterUser.firstName || "-", " ").concat(masterUser.lastName || "")
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* Typography */.ZT, {
                                                                                    variant: "text-sm",
                                                                                    color: "grayDark-400",
                                                                                    children: masterUser.email
                                                                                })
                                                                            ]
                                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: (header_module_default()).topUserEmailDiv,
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SkeletonTheme */.y, {
                                                                                    baseColor: "#202020",
                                                                                    highlightColor: "#444",
                                                                                    borderRadius: 50,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                                                        width: 100,
                                                                                        height: 20
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* SkeletonTheme */.y, {
                                                                                    baseColor: "#202020",
                                                                                    highlightColor: "#444",
                                                                                    borderRadius: 50,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* default */.Z, {
                                                                                        width: 150,
                                                                                        height: 20
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            src: "/logout.svg",
                                                                            alt: "Logout",
                                                                            width: 16,
                                                                            height: 16,
                                                                            onClick: handleLogout,
                                                                            style: {
                                                                                cursor: "pointer",
                                                                                marginRight: "8px"
                                                                            }
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (header_module_default()).hamburger,
                                        onClick: hamBurgerMenu,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: "/hamburger.svg",
                                            alt: "Hamburger",
                                            width: 40,
                                            height: 40
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            showChat && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/supportchat",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: "mainIcon",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/supportChatLogo.png",
                        alt: "Support Chat",
                        width: 173,
                        height: 93
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Header_Header = (Header);


/***/ }),

/***/ 16786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ setIsLoggedInCookie; },
/* harmony export */   "i": function() { return /* binding */ clearIsLoggedInCookie; }
/* harmony export */ });
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67924);

// Shared options for the non-sensitive `isLoggedIn` UI flag cookie (the
// actual auth token lives in localStorage, not a cookie - see
// utils/setAuth.js). `secure` is conditional on the page actually being
// served over HTTPS so it still works in local HTTP dev.
var isSecureContext = function() {
    return  true && window.location.protocol === "https:";
};
var setIsLoggedInCookie = function(value) {
    js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].set */ .Z.set("isLoggedIn", String(value), {
        expires: 365,
        secure: isSecureContext(),
        sameSite: "strict"
    });
};
var clearIsLoggedInCookie = function() {
    js_cookie__WEBPACK_IMPORTED_MODULE_0__/* ["default"].remove */ .Z.remove("isLoggedIn");
};


/***/ }),

/***/ 86737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81944);

var setAuthHeader = function(token) {
    if (token) {
        axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].defaults.headers.common.authorization */ .Z.defaults.headers.common.authorization = token;
    } else {
        delete axios__WEBPACK_IMPORTED_MODULE_0__/* ["default"].defaults.headers.common.authorization */ .Z.defaults.headers.common.authorization;
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (setAuthHeader);


/***/ }),

/***/ 47462:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerMainDiv":"header_headerMainDiv__skQGb","fadeInAnimation":"header_fadeInAnimation__uvqyk","headerPopupContainer":"header_headerPopupContainer__nCZkQ","headerChat":"header_headerChat__nyF5I","headerSubDiv":"header_headerSubDiv__viY1k","nav":"header_nav__t4xN3","mobilenav":"header_mobilenav__877Ls","options":"header_options__nVoDF","logo":"header_logo__x2KMD","links":"header_links__VELTz","linkItem":"header_linkItem__Gwxo2","dropdownArrow":"header_dropdownArrow__BR98S","linkStyle":"header_linkStyle__ORKUz","mainsigninButtonDiv":"header_mainsigninButtonDiv__aQ2ed","avatarIcon":"header_avatarIcon__1yJf1","cartIcon":"header_cartIcon__iXLoF","hamburger":"header_hamburger__oM_mZ","divider":"header_divider__XLqej","signinResponsiveDiv":"header_signinResponsiveDiv__uVyPc","slideInLeft":"header_slideInLeft__8hL_2","mainResponsivePopup":"header_mainResponsivePopup__xpOHC","topUserEmail":"header_topUserEmail__GwyxI","topUserEmailDiv":"header_topUserEmailDiv__PN80i","sidebar":"header_sidebar__EWgpH","menuItem":"header_menuItem__ndYA6","menuTitle":"header_menuTitle__XiUfu","subMenu":"header_subMenu__Y64MQ","subCategory":"header_subCategory__xhn1Y","subCategoryTitle":"header_subCategoryTitle__EMOBu","mobileServiceItem":"header_mobileServiceItem__ERqlr","mobileServiceIcon":"header_mobileServiceIcon__1DCbV","open":"header_open__uzpJh","slideDown":"header_slideDown__XFByB","productmainservicesContainer":"header_productmainservicesContainer__pn3AR","mainservicesContainer":"header_mainservicesContainer__R8lNK","dropdownOverlay":"header_dropdownOverlay__W61XI","servicesContainer":"header_servicesContainer__KnaJC","serviceSection":"header_serviceSection__R4TjI","serviceList":"header_serviceList__sT2a4","serviceItem":"header_serviceItem__BqwyW","arrowRightIcon":"header_arrowRightIcon__DeSXU","serviceIcon":"header_serviceIcon__UBDHE","serviceLabel":"header_serviceLabel__9QNBc","productservicesContainer":"header_productservicesContainer__Aihj_","productserviceSection":"header_productserviceSection__BPcij","productserviceList":"header_productserviceList__O3OnK","productserviceItem":"header_productserviceItem__VF0p1","productserviceIcon":"header_productserviceIcon__K0kiK","productserviceLabel":"header_productserviceLabel__DasLM"};

/***/ }),

/***/ 21416:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"profileDropdown":"profileview_profileDropdown__WQSZJ","profileContainer":"profileview_profileContainer__U_v0Z","profileMenu":"profileview_profileMenu__IAJwy","slideDown":"profileview_slideDown__RSFT8","mainResponsivePopup":"profileview_mainResponsivePopup__SA3Zg","toplogin":"profileview_toplogin__VF9Ku","topUserEmailDiv":"profileview_topUserEmailDiv__1CvPj","avatarIcon":"profileview_avatarIcon__XycP1","topUserEmail":"profileview_topUserEmail__Fm11x","divider":"profileview_divider__q7KHW","menuItem":"profileview_menuItem__BEtVc","menuIcon":"profileview_menuIcon__7k9eE"};

/***/ })

}]);